//判断是否是手机号
window.is_phone = function (phone) {
    if (typeof (phone) != 'string') {
        phone = phone.toString()
    }
    if (phone.length == 11) {
        return /1(3[0-9]|4(1|[4-9])|5((?!4)[0-9])|6[0-9]|7(0|1|[3-8])|8[0-9]|9[0-9])\d{8,8}/.test(phone)
    } else {
        return false
    }
}


window.countDown = function (endTime, func) {
    let date = [{
        date: '07',
        text: '天'
    },
    {
        date: '07',
        text: '时'
    },
    {
        date: '07',
        text: '分'
    },
    {
        date: '07',
        text: '秒'
    }
    ];
    var time = endTime * 1000;
    var nowTime = Date.now();
    var timediff = Math.round((time - nowTime) / 1000);
    function t(d) {
        if (d < 10) {
            if (d >= 1) {
                return '0' + d
            } else {
                return '00'
            }
        } else {
            return d
        }
    }
    //获取还剩多少天
    date[0].date = t(parseInt(timediff / 3600 / 24))
    //获取还剩多少小时
    date[1].date = t(parseInt((timediff / 3600) % 24))
    //获取还剩多少分钟
    date[2].date = t(parseInt((timediff / 60) % 60))
    //获取还剩多少秒
    date[3].date = t(timediff % 60);

    //输出还剩多少时间
    if (timediff >= 0) {
        func({ code: timediff == 0 ? -1 : 200, data: date });
    } else {
        func({ code: -1, data: date });
    }
}

window.setCookie = function (name, value, day) {

    if (day !== 0) { //当设置的时间等于0时，不设置expires属性，cookie在浏览器关闭后删除
        var d = new Date();
        d.setTime(d.getTime() + (day * 24 * 60 * 60 * 1000));
        document.cookie = name + "=" + escape(value) + ";expires=" + d.toGMTString() + "; path=/;";
    } else {
        document.cookie = name + "=" + escape(value) + "; path=/;";
    }
}

window.getCookie = function (name) {
    var arr;
    var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
        return unescape(arr[2]);
    else
        return null;
    ocument.cookie = name + "=" + escape(value);
}
window.is_weixn = function () {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
    } else {
        return false;
    }
}
window.is_ios = function () {
    const agent = navigator.userAgent
    return !!agent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
}

window.is_android = function () {
    const agent = navigator.userAgent
    return agent.indexOf('Android') > -1 || agent.indexOf('Adr') > -1;
}

window.shareShow = function () {
    if (!is_weixn()) {
        return
    }
    function onBridgeReady() {
        WeixinJSBridge.call('showOptionMenu');
    }
    if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
        } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
        }
    } else {
        onBridgeReady();
    }
}
window.shareHide = function () {
    if (!is_weixn()) {
        return
    }
    function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
    }
    if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
        } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
        }
    } else {
        onBridgeReady();
    }
}

window.requestAnimaFrame = (function () {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
        setTimeout(callback, 1000 / 60);
    }
})();


// WEBPACK FOOTER //
// ./src/public/public.js